import type { TransactionFilters } from '@/views/components/TransactionFilters'

export const getTransactionQueryParams = (take: number, skip: number, transactionFilters: TransactionFilters) => {
  const queryParams = new URLSearchParams()
  queryParams.set('take', take.toString())
  queryParams.set('skip', skip.toString())

  if (transactionFilters.dateFrom) {
    queryParams.set('dateFrom', new Date(transactionFilters.dateFrom).toISOString())
  }

  if (transactionFilters.dateTo) {
    const date = new Date(transactionFilters.dateTo)
    date.setHours(23, 59, 59, 999)
    queryParams.set('dateTo', date.toISOString())
  }

  if (transactionFilters.status) {
    queryParams.set('status', transactionFilters.status)
  }

  if (transactionFilters.categoryId) {
    queryParams.set('categoryId', transactionFilters.categoryId)
  }

  if (transactionFilters.type) {
    queryParams.set('type', transactionFilters.type)
  }

  return queryParams.toString()
}

export const getCardTransactionQueryParams = (
  take: number,
  skip: number,
  transactionFilters: Omit<TransactionFilters, 'status' | 'categoryId' | 'type'>,
) => {
  const queryParams = new URLSearchParams()
  queryParams.set('take', take.toString())
  queryParams.set('skip', skip.toString())

  if (transactionFilters.dateFrom) {
    queryParams.set('dateFrom', new Date(transactionFilters.dateFrom).toISOString())
  }

  if (transactionFilters.dateTo) {
    const date = new Date(transactionFilters.dateTo)
    date.setHours(23, 59, 59, 999)
    queryParams.set('dateTo', date.toISOString())
  }

  return queryParams.toString()
}
